// 선생님앱만의 판정 값. 규칙 로직은 shared(classify·shouldDrop)에 있고 여기엔 값만 둔다.
// expectedCodes 는 "FE 잘못" 이 아니라 서버가 정상 흐름으로 돌려주는 거절 코드다.

import {
  createNetworkSettleProbe,
  definePolicy,
  type ReportingPolicy,
} from '@mathflat/shared/@modules/errorReporting'

import { ERROR_CODE } from '@/constant/errorCode'

export const createTeacherPolicy = (deps: {
  origin: string
  isOnline: () => boolean
  isNetworkUnsettled: () => boolean
}): ReportingPolicy =>
  definePolicy({
    bundleOrigins: [deps.origin],
    clientFaultCodes: [],
    expectedCodes: [
      ERROR_CODE.FAVORITE_PROBLEM_CREATION_NOT_ALLOWED,
      'WORKSHEET_NOT_FOUND',
      'WRONG_REQUEST_CURRICULUM_GROUP',
    ],
    tokenRefreshRoutes: ['/v2/reissue'],
    // 결제 확정은 교재몰 서버(podAxios)가 아니라 메인 서버로 간다
    paymentRoutes: ['/pod/payment'],
    isOffline: () => !deps.isOnline(),
    isNetworkUnsettled: deps.isNetworkUnsettled,
  })

export const teacherPolicy = createTeacherPolicy({
  origin: window.location.origin,
  isOnline: () => navigator.onLine,
  isNetworkUnsettled: createNetworkSettleProbe({ win: window, doc: document }),
})
